module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-SemiBold.5e323fa0.woff";